
jQuery(document).ready(function() {logo_custom();});
var count=1;
function logo_custom() {
  // if ($('body').hasClass('template-index')) return; // No animation for homepage.

  jQuery('.logo-slider img').removeClass("logo-red");
  jQuery('.featured-logo-'+count).addClass("logo-red");
  jQuery('.logo-line div').removeClass("appear");
  jQuery('.logo-line'+count).addClass("appear");
  count=count+1;
  if (count == 6) {count = 1;}
  setTimeout(logo_custom, 3500);
}